import { AxiosResponse } from "axios";
import { AxiosInstance } from "./axiosInstance";
import {
  CameraWithRecorderRequest,
  CameraWithRecorderResponse,
  GetCameraMiniListResponse,
} from "./interfaces/cameraInterface.interface";
import {
  BasePagination,
  CustomError,
} from "./interfaces/commonInterface.interface";
import { GetCameraInfoResponse } from "./interfaces/recorderInterface.interface";
import qs from "qs";

const API_PATH = "/camera";

export const getCameraListWithRecorderList = async ({
  payload,
  accountId,
}: {
  payload: CameraWithRecorderRequest;
  accountId: string;
}): Promise<CameraWithRecorderResponse> => {
  try {
    const res: AxiosResponse<CameraWithRecorderResponse> =
      await AxiosInstance.post(`${API_PATH}/totalList/${accountId}`, payload);
    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getCameraInfo = async ({
  accountId,
  mergedSystemId,
  recorderId,
  payload,
}: {
  accountId: string;
  mergedSystemId: string;
  recorderId?: string;
  payload: BasePagination;
}): Promise<GetCameraInfoResponse> => {
  try {
    const res: AxiosResponse<GetCameraInfoResponse> = await AxiosInstance.get(
      recorderId
        ? `${API_PATH}/info/${accountId}/${mergedSystemId}/${recorderId}?${qs.stringify(
            payload
          )}`
        : `${API_PATH}/info/${accountId}/${mergedSystemId}?${qs.stringify(
            payload
          )}`
    );
    return res.data;
  } catch (e: any) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getCameraMiniList = async ({
  accountId,
}: {
  accountId: string;
}): Promise<GetCameraMiniListResponse> => {
  try {
    const res: AxiosResponse<GetCameraMiniListResponse> =
      await AxiosInstance.get(`${API_PATH}/miniList/${accountId}`);
    return res.data;
  } catch (e) {
    console.error(e);
    const customErr = e as CustomError;
    throw customErr;
  }
};
